module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro2--euro-c8e7c8e8e1095596ef8cafa8416d1984.jpg";